import { render, staticRenderFns } from "./PhotoCropper.vue?vue&type=template&id=be2a9b04&scoped=true&"
import script from "./PhotoCropper.vue?vue&type=script&lang=js&"
export * from "./PhotoCropper.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCropper.vue?vue&type=style&index=0&id=be2a9b04&lang=scss&scoped=true&"
import style1 from "./PhotoCropper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2a9b04",
  null
  
)

export default component.exports